import { BookOpen, InfinityIcon } from 'lucide-react';
import { cn } from './cn';
import type { PagingMode } from './pagingMode';

const OPTIONS = [
	{ id: 'scroll', icon: InfinityIcon, label: 'Infinite scroll' },
	{ id: 'pages', icon: BookOpen, label: 'Pages' },
] as const;

/** Infinite scroll (the default, so first) or pages. Styled to sit beside the apps' list/grid ViewToggle. */
export function PagingModeToggle({
	value,
	onChange,
}: {
	value: PagingMode;
	onChange: (mode: PagingMode) => void;
}) {
	return (
		<div className="inline-flex h-7 overflow-hidden rounded-lg border border-line-2 bg-surface-input">
			{OPTIONS.map((o, i) => {
				const active = value === o.id;
				return (
					<button
						key={o.id}
						onClick={() => onChange(o.id)}
						title={o.label}
						aria-label={o.label}
						aria-pressed={active}
						className={cn(
							'flex h-full w-7 cursor-pointer items-center justify-center transition-[background,color] duration-[120ms]',
							i > 0 && 'border-l border-line-2',
							active
								? 'bg-surface text-text-1'
								: 'bg-transparent text-text-3 hover:text-text-1'
						)}
					>
						<o.icon size={14} />
					</button>
				);
			})}
		</div>
	);
}
